import { Tag } from 'antd'
import { useTheme } from 'antd-style'

import { pick } from '@eastcoal/common/utils/object'

import { useAuthStore } from '@eastcoal/auth/hooks/useStore'

import { ManagerLinkProps } from './interface'

export const ManagerLink = ({
  className,
  style,
  variant = 'filled',
  color = 'volcano'
}: ManagerLinkProps) => {
  const { member } = useAuthStore(state => pick(state, ['member']))

  const { managerName, managerPhone } = member

  const theme = useTheme()

  return (
    <Tag
      className={className}
      color={color}
      variant={variant}
      style={{
        marginInline: theme.marginXXS,
        ...style
      }}
    >
      {managerName}：{managerPhone}
    </Tag>
  )
}
